export enum StatementStatusType {
    Issued = 1,
    Halted = 2,
}
